module.exports = __webpack_public_path__ + "img/John_R_Smith@2x.2b6237b2.png";